import React from 'react'
import Main from './Main'
import ProgressBar from 'react-animated-progress-bar';

function Skills() {
    let custProgressbar = {
        backGround : "#fff",
        color : "#000"
    }
    let defColor={
        fair: 'orangered',
        good: 'yellow',
        excellent: 'green',
        poor: 'red',
      }

    let centerDiv ={
        display : "flex",
        justifyContent : "center",
        alignItems : "center"
    }
    return (
        <>
           <Main active="skill">
               <div className="main">
               <section id="skills">
                    <div className="container">

                        <div className="section-title">
                            <h2 style={{"marginBottom":"0"}}>Skills</h2>
                        </div>

                        <div className="row skills-content">
                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-html5"></i>&nbsp;&nbsp;HTML</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="80" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-css3"></i>&nbsp;&nbsp;CSS</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="75" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-bootstrap"></i>&nbsp;&nbsp;BOOTSTRAP</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="80" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-javascript"></i>&nbsp;&nbsp;JAVASCRIPT</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="85" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-jquery"></i>&nbsp;&nbsp;JQUERY</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="80" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bx-file"></i>&nbsp;&nbsp;HANDLEBAR JS</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="70" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-react"></i>&nbsp;&nbsp;REACT</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="80" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-redux"></i>&nbsp;&nbsp;REDUX</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="70" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bx-layer"></i>&nbsp;&nbsp;NPM</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="85" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-nodejs"></i>&nbsp;&nbsp;NODE JS</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="70" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxs-server"></i>&nbsp;&nbsp;EXPRESS</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="85" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i class="fa fa-database" aria-hidden="true"></i>&nbsp;&nbsp;MYSQL</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="70" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i class="fa fa-database" aria-hidden="true"></i>&nbsp;&nbsp;MONGO DB</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="75" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bx-chart"></i>&nbsp;&nbsp;Highcharts</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="65" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 d-flex align-items-stretch">
                                <div className="card skill-card">
                                    <div className="card-body">
                                        <h5 className="card-title"><i className="bx bxl-git"></i>&nbsp;&nbsp;GIT</h5>
                                        <div style={centerDiv}>
                                            <ProgressBar width="230" trackWidth="13" percentage="60" fontColor={custProgressbar.color} bgColor={custProgressbar.backGround} defColor={defColor}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                 </section>
            </div>
               
           </Main> 
        </>
    )
}

export default Skills
